import { useEffect, useState } from "react";
import { useSignalGroupMembers } from "applications/signal/hooks/gqlHooks";
import FullScreenLoadCircle from "applications/signal/components/FullScreenLoadCircle";
import GroupMemberList from "applications/signal/components/GroupMemberList";
import { AlertSnackbarProps } from "features/components/alertSnackbar";
import { setGlobalMessage } from "hooks/useGlobalMessage";

export default function GroupMemberIndex() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackBarMessage, setSnackBarMessage] = useState<AlertSnackbarProps | null>(null);

  const { data, fetching, error, fetchSignalGroupMembers } = useSignalGroupMembers();
  useEffect(() => {
    // snackbarMessageを依存配列に入れることで、保存後に再取得を行う
    fetchSignalGroupMembers({
      item_offset: page * rowsPerPage,
      per_page: rowsPerPage,
    });
  }, [page, rowsPerPage, snackBarMessage]);

  useEffect(() => {
    if (error) {
      setGlobalMessage({
        message: "Signalグループメンバーの取得に失敗しました。",
        severity: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    if (snackBarMessage) {
      setGlobalMessage(snackBarMessage);
    }
  }, [snackBarMessage]);

  return (
    <>
      {fetching ? <FullScreenLoadCircle /> : null}
      <GroupMemberList
        rows={data?.getSignalGroupMembers.members || []}
        page={page}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={data?.getSignalGroupMembers.totalCount || 0}
        setSnackBarMessage={setSnackBarMessage}
      />
    </>
  )
}
